/* eslint-disable no-undef */

export const getFormData = (data) => {
  const formData = new FormData();
  let isFileInData = false;
  for (const name in data) {
    if (data[name]) formData.append(name, data[name]);
    if (data[name] instanceof File) isFileInData = true;
  }

  return isFileInData ? formData : null;
};



// WEBPACK FOOTER //
// ./src/helpers/api/formData.js